/*  MUI  */
import { Grid, Tab, Typography } from '@mui/material';

/*  Shared  */
import { PageTitle } from 'application/Shared/Components/App';
import { MUITabsWrapper } from 'application/Shared/Components/MUITabsWrapper';
import { Route, SessionHelper } from 'application/Shared/Helpers';
import { ManageUsers, Permissions } from 'application/Shared/Pages';

/* Hooks */
import { useSession } from 'hooks/redux/Selectors/session';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router';

const Page = () => {
    const { t } = useTranslation();
    const { tab } = useParams();

    switch (tab) {
        case 'permissions':
            return <Permissions noTitle />;
        case 'users':
        default:
            return (
                <>
                    <Typography
                        variant="h4"
                        style={{
                            fontWeight: 600,
                            marginBottom: '32px',
                            marginTop: '24px'
                        }}
                    >
                        {t('ManageUsers.partner_users')}
                    </Typography>
                    <ManageUsers />
                </>
            );
    }
};

const PageContent = () => {
    const session = useSession();

    const sessionHelper = new SessionHelper(session);

    // Show tabs if Global Admin or if not ANM
    const showTabs = sessionHelper.isGlobalAdmin() || !sessionHelper.isANM();

    if (!showTabs) {
        return <Page />;
    }

    return (
        <>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <PageTabs sessionHelper={sessionHelper} />
                </Grid>
            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Page />
                </Grid>
            </Grid>
        </>
    );
};

const PageTabs = ({ sessionHelper }) => {
    const { t } = useTranslation();
    const { partnerId, tab } = useParams();
    const activeTab = tab ?? 'users';

    const basePartnerRoute = Route.buildBasePartnerRoute({ partnerId });

    return (
        <MUITabsWrapper value={activeTab}>
            <Tab
                component={Link}
                data-trackid="manageUsersTab"
                to={`${basePartnerRoute}/manageUsers/users`}
                value="users"
                label={t('Common.manage_users')}
            />
            {sessionHelper.hasPermission('default_admin') && (
                <Tab
                    component={Link}
                    data-trackid="managePermissionGroupsTab"
                    to={`${basePartnerRoute}/manageUsers/permissions`}
                    value="permissions"
                    label={t('Common.manage_permission_groups')}
                />
            )}
        </MUITabsWrapper>
    );
};

export const PartnerManageUsers = () => {
    const { t } = useTranslation();

    return (
        <>
            <PageTitle title={t('Common.manage_users')} />
            <PageContent />
        </>
    );
};
